import { t } from "@/i18n-js/instance";
import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";
import { useSmOrMdScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { BadgeV2 } from "@circle-react-uikit/BadgeV2";

export const EnterpriseOfferBadge = () => {
  const isMobile = useSmOrMdScreenMediaQuery();
  const { isVariantAEnabled } = usePlanPageVariant();
  const shouldTruncate = isVariantAEnabled && isMobile;

  return (
    <>
      <style>
        {`
          .enterprise-offer-badge {
            border-color: transparent !important;
          }
          .enterprise-offer-badge > span {
            color: white !important;
          }
        `}
      </style>
      <BadgeV2
        square
        label={t("pricing_plans.enterprise_limited_time_offer")}
        inverted
        className="enterprise-offer-badge truncate bg-blue-600"
        truncateLength={shouldTruncate ? 10 : undefined}
      />
    </>
  );
};
